<template>
  <responsive-drawer-header :color="theme.appBar.other.color" :hasDrawer="false" :moduleUnreadCount="unreadCountsByInstance[$route.params.instance]">
    <template v-slot:drawer-module-title>{{ mx_moduleTitle }}</template>

    <!-- left container -->
    <template v-slot:left-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:left-subtitle>
      <div v-if="isLoaded">{{ selectedItemTitle }}</div>
      <div v-else>{{ $t('fahrdienst452.noSelection') }}</div>
    </template>

    <template v-slot:right>
      <!-- right content in case of tour mode -->

      <!-- right content in case of document mode -->
      <div v-if="mdAndUp && isLoaded && displayedDocument" class="d-flex align-center">
        <favorite-icon :color="color" :item="displayedDocument"></favorite-icon>

        <!-- currently not implemented on cockpit side -->
        <!-- <favorite-icon v-if="!xs" :item="displayedDocument" :activeColor="color" :inactiveColor="color"></favorite-icon> -->
      </div>

      <div class="mr-0 d-flex flex-wrap justify-end">
        <v-menu offset-y style="width: 130px !important">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="my-1 mx-1" :style="{ width: xs ? '60px' : '120px' }" rounded outlined :x-small="xs" :color="color" v-bind="attrs" v-on="on"
              >{{ selectedType ? selectedType.value : 'Typ' }}
            </v-btn>
          </template>
          <v-list :max-height="360" class="list-with-scrollbar">
            <v-list-item v-for="(item, index) in attributeTypes" :key="index" @click="selectedType = item">
              <v-list-item-title>{{ item.value }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <matrix-menu
          v-if="selectedType"
          v-model="selectedLine"
          class="my-1 mx-1"
          :btnWidth="xs ? '60px' : '120px'"
          :title="selectedType ? selectedType.value : $t('fahrplan.type')"
          :text="selectedLine ? selectedLine : 'Linie'"
          @onCellSelected="(item) => (selectedLine = item)"
          :color="color"
          :rows="lineRows"
        ></matrix-menu>
      </div>

      <div v-if="isLoaded" class="d-flex align-center">
        <v-menu bottom :max-width="400" :small="xs" left transition="slide-y-transition" offset-y close-on-click close-on-content-click>
          <template v-slot:activator="{ on, attrs }">
            <v-btn :color="color" fab class="d-flex trx-15" icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list dense>
            <download v-if="features.enableDocumentDownload !== false && documentId" listItem :downloadUrl="documentUrl" :color="color"></download>

            <!-- favorite currently not implemented on cockpit side -->
            <favorite-icon v-if="smAndDown" :disabled="!documentId" listItem :item="displayedDocument"></favorite-icon>
            <share-button v-if="documentId" listItem :file="displayedDocument" :moduleBackendId="moduleBackendId" :color="color"></share-button>
          </v-list>
        </v-menu>
      </div>
    </template>
  </responsive-drawer-header>
</template>

<script>
import { mapState } from 'vuex';
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import ResponsiveDrawerHeader from '@/layouts/ResponsiveDrawerHeader.vue';
import Download from '@//components/buttons/Download.vue';
import ShareButton from '@/components/buttons/ShareButton.vue';
import FavoriteIcon from '@/components/buttons/FavoriteIcon.vue';
import acknowledgeService from '@/services/acknowledgeService';
import readService from '@/services/readService';
import index from './index';
import { ROUTE_FAHRPLAN_DOC } from './routes';
import MatrixMenu from '@/components/menus/MatrixMenu';

export default {
  name: 'FahrdienstHeader',
  mixins: [common, configMixin, dateTimeMixin],
  components: {
    FavoriteIcon,
    ResponsiveDrawerHeader,
    Download,
    ShareButton,
    MatrixMenu,
  },
  created() {
    console.debug('dutiesAtSelectedDate ', this.dutiesAtSelectedDate);
    let documentId = this.$route.params.documentId;

    if (!documentId) {
      this.$nextTick(() => {
        if (!this.selectedType && this.attributeTypes && this.attributeTypes.length > 0 && this.lines) {
          this.selectedType = this.attributeTypes[0];

          if (this.lines && this.lines.length > 0) {
            this.selectedLine = this.lines[0];
          }
        }
      });
    } else {
      this.$nextTick(() => {
        let file = this.fahrplanFilesById[documentId];
        if (file) {
          // let file = this.fahrplanFiles.find((f) => f.type === this.displayedDocument.type);
          this.selectedType = this.attributeTypes.find((a) => a.name === 'type' && a.value === file.linie);
          this.selectedLine = file.linie;
        }
      });
    }
  },

  computed: {
    ...mapState('fahrplan', ['isLoaded', 'selectedDayType', 'fahrplanFiles', 'fahrplanFilesById', 'fahrplanAttributes', 'unreadCountsByInstance']),
    selectedType: {
      get() {
        return this.$store.state.fahrplan.selectedType;
      },
      set(type) {
        this.$store.commit('fahrplan/setSelectedType', type, { root: true });
      },
    },
    selectedLine: {
      get() {
        return this.$store.state.fahrplan.selectedLine;
      },
      set(line) {
        console.debug('setSelectedLine', line);
        this.$store.commit('fahrplan/setSelectedLine', line, { root: true });
      },
    },
    moduleType: () => index.moduleType,
    moduleBackendId: () => index.api,
    // route param
    instance() {
      return Number(this.$route.params.instance);
    },
    // route param
    documentId() {
      return this.$route.params.documentId;
    },

    displayedDocument() {
      return this.documentId ? this.fahrplanFilesById[this.documentId] : null;
    },
    documentUrl() {
      return this.displayedDocument ? this.constructPdfJsFileUrl(this.moduleBackendId, this.displayedDocument, 'filename') : null;
    },
    isRead() {
      return readService.isRead(this.displayedDocument);
    },

    isToAcknowledge() {
      return acknowledgeService.isToAcknowledge(this.displayedDocument);
    },
    attributeTypes() {
      return this.fahrplanAttributes.filter((t) => t.instance === this.instance && t.name === 'type' && this.getFilesOfType(t.value).length > 0);
    },

    lines() {
      return this.selectedType ? this.getFilesOfType(this.selectedType.value) : [];
    },
    lineRows() {
      console.debug('calculate lineRows', this.lines);
      let rows = [];
      let colCount = 5;
      let row = [];
      rows.push(row);
      this.lines.forEach((line) => {
        row.push(line);
        if (row.length >= colCount) {
          row = [];
          rows.push(row);
        }
      });
      console.debug('calculate lineRows', rows);
      return rows;
    },

    selectedItemTitle() {
      let title = '';
      if (this.displayedDocument) {
        title += `${this.displayedDocument.title}`;
      }

      return title;
    },

    color() {
      return this.theme.appBar.other.color;
    },
  },
  methods: {
    getFilesOfType(attributeValue) {
      let lines = this.fahrplanFiles
        .filter((t) => t.instance === this.instance && t.type === attributeValue)
        // .filter((t) => t.instance === this.instance && this.selectedType && t.type === this.selectedType.name)
        .map((i) => i.linie);
      return lines;
    },
    displayFile() {
      if (this.selectedType && this.isLoaded) {
        let { instance, documentId } = this.$route.params;
        let file = this.fahrplanFiles.find((f) => f.type === this.selectedType.value && f.linie === this.selectedLine);
        if (file && documentId !== file.id) {
          console.debug('push navigation to documentId=', file.id);
          this.$router.push({
            name: ROUTE_FAHRPLAN_DOC,
            params: { instance: this.instance, documentId: file.id },
          });
        }
      }
    },
  },
  watch: {
    selectedLine(newValue, oldValue) {
      if (oldValue !== newValue) {
        this.displayFile();
      }
    },
  },
};
</script>
